import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { serverError } from '@core/models/messages';
import { EsnConsultantService } from '@core/services/esn-consultant/esn-consultant.service';
import { IntervenantService } from '@core/services/intervenant/intervenant.service';
import { StripeService } from '@core/services/stripeService/stripe-service.service';
import { environment } from '@env/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-down-grade-modal',
  templateUrl: './down-grade-modal.component.html',
  styleUrls: ['./down-grade-modal.component.css']
})
export class DownGradeModalComponent implements OnInit , OnChanges{
  subscription: any;  // Receive the subscription input
  currentFeatureUsage: any;  // Receive the subscription input
  hasSubscription: boolean = false;  // Initialize the hasSubscription variable
  modalRef?: BsModalRef;
  listconsultant: any = [];
  selectedConsultant: any = [];
  listintervenant: any = [];
  selectedIntervenant: any = [];
  lowerUsageFeatures: any[] = [];
  urlimage: string = environment.baseUrlGalery;
  url: string = environment.baseUrl + '/api';
  constructor(
    private stripeService: StripeService,
    private esnConsultantService: EsnConsultantService,
    private intervenantService: IntervenantService,
    private toastr: ToastrService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hasSubscription'] && changes['hasSubscription'].currentValue) {
        console.log('hasSubscription', this.hasSubscription);
    }
    if (changes['subscription'] && changes['subscription'].currentValue) {
        console.log('subscription', this.subscription);
    }
}
  ngOnInit() {
    this.getLowerUsageFeatures();
    this.getListConsultants();
    this.getListIntervenants();
   }
   downgrade() {
    const selectedConsultantIds = this.selectedConsultant.map((consultant: any) => consultant.id);
    const selectedIntervenantIds = this.selectedIntervenant.map((intervenant: any) => intervenant.id);
  
    const downgradeData = {
      selectedConsultantIds,
      selectedIntervenantIds,
    };
  
    // Call downgrade and archive endpoint
    this.stripeService.archive(downgradeData).subscribe({
      next: () => {
        this.modalRef?.hide();
        this.toastr.success('Rétrogradation et archivage réussis');
  
        // Reload the page after a 2-second delay
        setTimeout(() => {
          window.location.reload();
        }, 2000); // 2000 milliseconds = 2 seconds
      },
      error: (error: any) => {
        console.error('Error in downgrade and archive:', error);
        this.toastr.error('Échec de la rétrogradation et de l’archivage');
      }
    });
  }
  

  getLowerUsageFeatures() {
    this.lowerUsageFeatures = [];
    this.selectedConsultant = [];
    this.selectedIntervenant = [];
    // Check if there's an active subscription to compare with
    console.log('getLowerUsageFeatures subscription',this.hasSubscription);
    if (this.hasSubscription) {
      // Loop through each feature in recent_offer to compare with current usage
      for (const feature of this.subscription.features) {
        const currentUsage = this.currentFeatureUsage.find((f: any) => f.id === feature.id);
        
        if (currentUsage && !currentUsage.unlimited_usage) {
          const maxUsage = feature.pivot?.metadata?.max_usage;
          const currentUsed = currentUsage.used;
          
          // Check if there’s a defined max_usage and if current usage exceeds this limit
          if (maxUsage !== null && maxUsage < currentUsed) {
            this.lowerUsageFeatures.push({ 'feature': feature.name, 'max_usage': maxUsage, 'current_usage': currentUsed });
          }
        }

      }
    }
  }
  // Method to determine if button should be disabled
  canDowngrade(): boolean {
    return !this.isOverLimit('Limite consultants', this.selectedConsultant) &&
      !this.isOverLimit('Limite intervenants', this.selectedIntervenant);
  }


  isOverLimit(featureName: string, list: any[]): boolean {
    const feature = this.lowerUsageFeatures.find(f => f.feature === featureName);
    return feature ? (feature.current_usage - list.length) > feature.max_usage : false;
  }
  onCheckboxChange(event: any, data: any, list: any[]) {
    if (event.target.checked) {
      list.push(data); // Push data to list if checked
    } else {
      const index = list.findIndex((item: any) => item.id === data.id);
      if (index > -1) {
        list.splice(index, 1); // Remove data from list if unchecked
      }
    }
  }
  getFormattedFeatureText(featureName: string, list: any[]): string {
    console.log(featureName, this.lowerUsageFeatures);
    
    return this.lowerUsageFeatures.filter(f => f.feature === featureName)
      .map(f => `${f.feature} (${(f.current_usage - list.length)} / ${f.max_usage})`)
      .join('\n');
  }
  getListConsultants() {
    this.esnConsultantService.getAllConsultants().subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
      },
      error: () => {
        this.toastr.error(serverError);
      }
    });
  }
  getListIntervenants() {
    this.intervenantService.getAllIntervenants().subscribe({
      next: (res: any) => {
        this.listintervenant = res.data;
      },
      error: () => {
        this.toastr.error(serverError);
      }
    });
  }

  closeModal() {
    this.modalRef?.hide();
  }
}
